import React from 'react';

import { i18n } from '../i18n';

import * as css from './p4f.module.css';

export default function P4f() {
    return <div className={css.p4f}>
        <h2 className={css.title}>{i18n('part4.p4f.header')}</h2>
        <p>{i18n('part4.p4f.para.0')}</p>

        <div className={css.buttonWrap}>
            <a className={css.button} href={i18n('part4.p4f.href', { md : false })} target='_blank' rel='noreferrer'>
                {i18n('part4.p4f.cta')}
            </a>
        </div>
    </div>;
}
